import { useQuery } from '@tanstack/react-query';
import { useApiClients } from '../ApiClientsProvider';
import { queryClient } from '../query-client';
import MarketApiClient from '../clients/market-api/market-api.client';

export const useMarketHours = () => {
  const { marketApi } = useApiClients();

  return useQuery({
    queryKey: ['market-hours'],
    queryFn: async () => {
      return marketApi.getMarketHours();
    },
    staleTime: 1000 * 60 * 60,
    refetchInterval: 1000 * 60,
  });
};

export const ensureMarketHours = async () => {
  return await queryClient.ensureQueryData({
    queryKey: ['market-hours'],
    queryFn: async () => {
      return MarketApiClient.getMarketHours();
    },
    staleTime: 1000 * 60 * 60,
  });
};

export const prefetchMarketHours = async () => {
  return await queryClient.prefetchQuery({
    queryKey: ['market-hours'],
    queryFn: async () => {
      return MarketApiClient.getMarketHours();
    },
    staleTime: 1000 * 60 * 60,
  });
};
